import React, { Key } from "react";
import style from "./index.module.scss";
import { Button, Icon, Input } from "antd";
import useModalHandler from "../../../../../../../utils/useModalHandler";
import MembersModal from "../MembersModal";
import { GroupType } from "../../../../../../../service/group";

interface ToolsProps {
    setSearchText: (val: string) => void;
    onDelete: () => void; //批量移除
    selected: Key[]; //选中id
    onUpdateMemberList: () => void; //更新已分组成员列表
    type?: GroupType;
    randomGroupKey?: string;
    canEdit?: boolean;
}
export default function Tools({
    setSearchText,
    onDelete,
    selected,
    randomGroupKey,
    type = GroupType.base,
    canEdit = true,
    onUpdateMemberList
}: ToolsProps) {
    const { Search } = Input;
    const modal = useModalHandler();

    const onOk = () => {
        modal.close();
        onUpdateMemberList();
    };

    return (
        <div className={style.root}>
            <Search
                placeholder="请输学生姓名或学号"
                onSearch={value => setSearchText(value)}
                style={{ width: 200 }}
            />
            {canEdit && (
                <>
                    <Button
                        type="primary"
                        ghost
                        className={style.addBtn}
                        onClick={modal.open}>
                        <Icon type="user-add" />
                        添加组员
                    </Button>
                    {selected.length !== 0 && (
                        <Button
                            type="primary"
                            ghost
                            className={style.addBtn}
                            onClick={onDelete}>
                            <Icon type="switcher" />
                            批量删除
                        </Button>
                    )}
                </>
            )}

            {modal.render(
                <MembersModal
                    randomGroupKey={randomGroupKey}
                    type={type}
                    visible={modal.visible}
                    onOk={onOk}
                    onCancel={modal.close}
                />
            )}
        </div>
    );
}
